const ALLOWED_DASHBOARD_IDS_BY_USER = {
  7: [1, 2],
};

const getAllowedDashboardIds = (userId) => {
  // undefined: akses penuh; []: tidak ada dashboard yang diizinkan.
  return ALLOWED_DASHBOARD_IDS_BY_USER[Number(userId)];
};

const isDashboardAllowed = (userId, dashboardId) => {
  const allowedDashboardIds = getAllowedDashboardIds(userId);

  if (allowedDashboardIds === undefined) {
    return true;
  }

  return allowedDashboardIds.includes(Number(dashboardId));
};

const findFirstAllowedDashboardIndex = (dashboardSource, userId) => {
  return dashboardSource.findIndex(
    (dashboard) => isDashboardAllowed(userId, dashboard.id)
  );
};

export {
  findFirstAllowedDashboardIndex,
  getAllowedDashboardIds,
  isDashboardAllowed,
};
